import { DrugDrugInteractionResult } from "domain/entities/drug-drug-interaction";
import { DrugDrugInteractionRepository } from "domain/repositories";

export default class GetAllUseCase {
    private drugDrugInteractionRepository: DrugDrugInteractionRepository;
    
    public constructor(drugDrugInteractionRepository: DrugDrugInteractionRepository) {
        this.drugDrugInteractionRepository = drugDrugInteractionRepository
    }

    public async getAllDrugDrugInteractions(token: Promise<[string | null, string | null]>): Promise<[DrugDrugInteractionResult[], null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugDrugInteractionRepository.getAllDrugDrugInteraction(t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}